import { render, staticRenderFns } from "./ProdutosSkus.vue?vue&type=template&id=02f91429&scoped=true&"
import script from "./ProdutosSkus.vue?vue&type=script&lang=js&"
export * from "./ProdutosSkus.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosSkus.vue?vue&type=style&index=0&id=02f91429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f91429",
  null
  
)

export default component.exports